/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLTIProvider } from './BaseLTIProvider';
const BaseLTI1p1ProviderParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'lms',
        /* #__PURE__ */ parsers.exactly('Blackboard', 'BrightSpace', 'Canvas', 'Moodle', 'Open edX', 'Populi', 'Sakai', 'Thought Industries'),
    ],
    ['version', /* #__PURE__ */ parsers.exactly('lti1.1')],
    ['supportsLockDate', codecBoolean, 'supports_lock_date'],
]), BaseLTIProvider);
export class BaseLTI1p1Provider extends BaseLTIProvider {
    static decode(input) {
        return BaseLTI1p1ProviderParser.decode(input).map(res => new BaseLTI1p1Provider(res));
    }
    static unsafeDecode(input) {
        return BaseLTI1p1Provider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseLTI1p1ProviderParser.encode(data);
    }
    static schema() {
        return BaseLTI1p1ProviderParser.schema();
    }
}
